module.exports = __webpack_public_path__ + "static/img/exploit5.457151dd.png";